<template>
  <div class="list-container">
    <div class="list-section">
      <div class="bread-crumbs">
        <router-link to="/">首页</router-link>
        <template v-if="breadcrumbList.length">
          <router-link v-for="nav in breadcrumbList" :key="`nav-${nav.id}`" :to="`/store/${nav.codePath}`">{{ nav.name
          }}</router-link>
        </template>
      </div>
      <!-- 列表头部 -->
      <div class="list-header">
        <div class="list-title">{{ categoryRes.name ? categoryRes.name : '列表' }}({{ total }})</div>
        <div class="list-header-extra">
          <!-- 移动端：点击打开左侧筛选抽屉 -->
          <div class="list-filter-mini" @click="openFilterDrawer">筛选</div>
          <div class="list-sort">
            <el-select class="sort-items" v-model="sort" placeholder="排序方式" @change="optsChange('sort')">
              <el-option value="default" label="默认"></el-option>
              <el-option value="new" label="最新发售"></el-option>
              <el-option value="sales" label="销量"></el-option>
              <el-option value="price:desc" label="价格↓"></el-option>
              <el-option value="price:asc" label="价格↑"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="list-wrapper">
        <div class="filter-items">
          <ListFilter scope="category" :filterOpts="filterOpts"
            :title="`${breadcrumbList.length ? breadcrumbList[0].name : ''}`" />
        </div>
        <div class="list-items">
          <!-- 专题Banner -->
          <div class="topic-banner" v-if="pics && (pics.big || pics.small)">
            <picture class="homepage-content-main-image">
              <source v-if="pics.small" media="(max-width:640px)" :srcset="pics.small" />
              <img media="(min-width:768px)" :src="pics.big" />
            </picture>
          </div>

          <!-- 已选过滤条件 -->
          <div class="list-filter-opts-selected" v-if="showSelectedFilterItem">
            <div class="list-filter-flag">筛选</div>
            <!-- 已选过滤条件：分类 -->
            <template v-if="getCheckedList('category').length">
              <div class="filter-item">
                <span class="filter-item-name">分类: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('category')" :key="i">
                  {{ item | findFilterItem(filterOpts['category']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('category', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：性别 -->
            <template v-if="getCheckedList('genders').length">
              <div class="filter-item">
                <span class="filter-item-name">性别: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('genders')" :key="i">
                  {{ item | findFilterItem(filterOpts['genders']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('genders', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：尺寸 -->
            <template v-if="getCheckedList('sizes').length">
              <div class="filter-item">
                <span class="filter-item-name">尺码: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('sizes')" :key="i">
                  {{ item | findFilterItem(filterOpts['sizes']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('sizes', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：颜色 -->
            <template v-if="getCheckedList('colors').length">
              <div class="filter-item">
                <span class="filter-item-name">颜色: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('colors')" :key="i">
                  {{ item }}
                  <a class="filter-item-remove" @click="removeFilterItem('colors', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：系列 -->
            <template v-if="getCheckedList('series').length">
              <div class="filter-item">
                <span class="filter-item-name">系列: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('series')" :key="i">
                  {{ item | findFilterItem(filterOpts['series']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('series', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：品牌 -->
            <template v-if="getCheckedList('brand').length">
              <div class="filter-item">
                <span class="filter-item-name">品牌: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('brand')" :key="i">
                  {{ item | findFilterItem(filterOpts['brand']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('brand', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：衣长 -->
            <template v-if="getCheckedList('clothingLength').length">
              <div class="filter-item">
                <span class="filter-item-name">衣长: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('clothingLength')" :key="i">
                  {{ item | findFilterItem(filterOpts['clothingLength']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('clothingLength', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：袖长 -->
            <template v-if="getCheckedList('sleeveLength').length">
              <div class="filter-item">
                <span class="filter-item-name">袖长: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('sleeveLength')" :key="i">
                  {{ item | findFilterItem(filterOpts['sleeveLength']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('sleeveLength', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：尺寸 -->
            <template v-if="getCheckedList('measurements').length">
              <div class="filter-item">
                <span class="filter-item-name">尺寸: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('measurements')" :key="i">
                  {{ item | findFilterItem(filterOpts['measurements']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('measurements', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <div class="clear-all" @click="clearAll">清除</div>
          </div>
          <!-- 列表主体 -->
          <div class="list-context">
            <ul class="list-result">
              <li v-for="(item, index) in list" :key="index">
                <ListItem :data="item" :isGwMdEnablePoint="isGwMdEnablePoint" :hasBrand="hasBrand"
                  @itemview="showItemDialog" scope="list" />
              </li>
            </ul>
            <div class="paging">
              <Pagination :total="total" :limit="limit" :current="currPage" @change="changePage" />
              <div class="list-footer-size">
                <label htmlFor="footer-limit-size" class="list-footer-size-hits">查看:&nbsp;</label>
                <el-select class="list-footer-size-items" v-model="limit" placeholder="每页大小"
                  @change="optsChange('limit')">
                  <el-option :value="24" label="24"></el-option>
                  <el-option :value="48" label="48"></el-option>
                  <el-option :value="96" label="96"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 快速购买 - 商品弹窗 -->
    <div class="dialog view-item-dialog" v-if="viewItem && viewItem.id && viewItem.color">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <div class="dialog-title">商品信息</div>
          <button type="button" class="dialog-close" @click="hideItemDialog">
            <span class="close-icon"></span>
          </button>
        </div>
        <div class="dialog-body">
          <ViewItemInfo scope="list" :id="viewItem.id" :isGwMdEnablePoint="isGwMdEnablePoint" :color="viewItem.color"
            :styleNumber="viewItem.style_number" confirmText="加入购物车" @notify="setNotify" @confirm="addToCart"
            @checkout="toBuyNow" />
        </div>
      </div>
    </div>
    <!-- 快速购买 - 加购成功弹窗（共用组件，无遮罩、吸在当前 header 下方） -->
    <CartSuccessDialog :info="cartInfo" :headerHeight="headerHeight" @close="closeCartDialog(0)"
      @checkout="toCheckout" @cart="toCart" :isGwMdEnablePoint="isGwMdEnablePoint"/>
    <!-- 快速购买 - 通知弹窗 -->
    <div class="dialog notify-dialog" v-if="notifyItem">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <div class="dialog-title">到货通知</div>
          <button class="dialog-close" @click="hideNotifyDialog">
            <span class="close-icon"></span>
          </button>
        </div>
        <div class="dialog-body">
          <ItemNotify :source="notifyItem" @comfirm="sendNotify" />
        </div>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <div class="dialog login-dialog" v-if="showLogin">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="hideLoginDialog">&#xe612;</i>
        </div>
        <div class="dialog-body">
          <Login :returnUrl="returnUrl" />
        </div>
      </div>
    </div>
    <!-- 移动端筛选抽屉 -->
    <MobileFilterDrawer :filterOpts="filterOpts" :visible="filterDrawerVisible" :total="total"
      @close="filterDrawerVisible = false" />
  </div>
</template>

<script>
// @ is an alias to /src
import types from '@/store/types';
import api from '@/utils/api';
import ListFilter from '@/components/ListFilter.vue';
import MobileFilterDrawer from '@/components/MobileFilterDrawer.vue';
import ListItem from '@/components/ListItem.vue';
import ViewItemInfo from '@/components/ViewItemInfo.vue';
import ItemNotify from '@/components/ItemNotify.vue';
import Login from '@/components/Login.vue';
import CartSuccessDialog from '@/components/CartSuccessDialog.vue';
import utils from "@/utils";
import Pagination from '@/components/Pagination.vue';

// List/Search 共用的筛选页逻辑（query 解析/where 构建/已选管理/抽屉开关）
import filterPageMixin from '@/mixins/filterPage';

export default {
  name: 'List',
  components: { ListFilter, MobileFilterDrawer, Pagination, ListItem, ViewItemInfo, ItemNotify, Login, CartSuccessDialog },
  mixins: [filterPageMixin],
  data() {
    return {
      pics: null,                   // 分类Banner
      list: [],                     // 商品列表
      // 筛选/分页等共享状态在 filterPage mixin 中声明；默认排序与搜索页统一为「默认」
      defaultSort: 'default',
      //
      viewItem: null,
      cartInfo: null, // 加购成功弹层数据
      headerHeight: 0, // 加购成功弹层吸顶偏移（弹出时实时测量）
      notifyItem: null,
      showLogin: false,
      returnUrl: '',
      pendingBuyNow: null, // 未登录点立即购买暂存的直购参数，登录成功后自动重放
      categoryRes: {
        breadcrumb: [],
        name: '',
      },
      skipNextLoad: false // 老路由 URL 归一化 replace 导致的路由变化无需重新加载
    }
  },
  created() {
    // 兼容新路由 (urlKey+code) 和老路由 params.id
    let category = this.getRouteCategoryKey();
    if (category) {
      // 
    } else {
      this.$router.replace({ name: 'Home' });
    }
  },
  mounted() {
    this.initWithArgs();
  },
  // PDP 返回 PLP 停留原位置: 进入时若来源是 PDP, 标记待恢复(loadSource 完成后恢复位置而非滚顶)
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm._restoreScroll = from.path.indexOf('/product') === 0;
    });
  },
  // 进入 PDP 前记录当前滚动位置(带分类 key 防止从其他列表恢复错位)
  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf('/product') === 0) {
      sessionStorage.setItem('plp:scroll', JSON.stringify({
        key: this.getRouteCategoryKey(),
        y: window.scrollY
      }));
    }
    next();
  },
  methods: {
    initWithArgs() {
      // 筛选/排序/分页解析在共享 mixin 的 parseRouteQuery 中
      this.parseRouteQuery(this.$route.query);
      // 切换分类(头尾菜单等任意入口都体现为路由分类参数变化)时, 分组恢复为配置的默认展开状态;
      // 分类树节点 _collapse 由 applyFilters 按旧树回填保留
      const categoryKey = this.getRouteCategoryKey();
      if (this._lastCategoryKey !== undefined && this._lastCategoryKey !== categoryKey) {
        this.resetFilterCollapse();
      }
      this._lastCategoryKey = categoryKey;
      this.loadSource();
    },
    // 新路由完整分类路径: /store/:urlKey*/:code 的 urlKey(中间段)与 code(末段) 合并, 老路由取 params.id
    getRouteCategoryKey() {
      const { urlKey, code, id } = this.$route.params;
      return [urlKey, code].filter(Boolean).join("/") || id || "";
    },
    // 更改页码: 写入路由 query, 由 $route watch 统一触发重新加载 (与 optsChange 同路径); 第 1 页不落参数
    changePage({ currPage: page }) {
      let query = Object.assign({}, this.$route.query);
      page > 1 ? (query.page = page) : delete query.page;
      this.$router.push({
        path: this.$route.path,
        query: query
      });
    },
    loadSource() {
      // 兼容新路由 (urlKey+code 合并) 和老路由 params.id
      // 新路由完整路径为多段 (如 3/56/666), 取最后一段作为分类 id
      const urlKey = this.getRouteCategoryKey();
      let newArgs = this.buildWhereArgs();
      // 接口要求 id 为字符串, 取分类路径最后一段原始字符串, 不做数字转换
      newArgs.id = urlKey.split('/').pop();
      api[types.GET_LIST_BY_NAV_ID](newArgs).then(res => {
        if (res?.code == 1) {
          let { list, total, category } = res.data;
          this.categoryRes = category;
          utils.setPageTitle(category.name)
          this.list = list;
          this.total = total;
          this.pics = category?.pic;
          // 老路由进来: 用 category_code_path 拼到 /store/ 后 replace 成新 URL, 缺失时兜底分类 id
          if (this.$route.meta.legacy && category?.category_code_path) {
            this.skipNextLoad = true;
            this.$router.replace({
              path: `/store/${category?.category_code_path}`,
              query: this.$route.query
            });
          }
          this.$nextTick(() => {
            // 从 PDP 返回: 数据渲染完成后恢复离开前的滚动位置(分类 key 一致才恢复), 不滚回顶部
            if (this._restoreScroll) {
              this._restoreScroll = false;
              const saved = JSON.parse(sessionStorage.getItem('plp:scroll') || 'null') || {};
              if (saved.key === this.getRouteCategoryKey() && typeof saved.y === 'number') {
                sessionStorage.removeItem('plp:scroll');
                window.scrollTo(0, saved.y);
                return;
              }
            }
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
          });
        }
      }).catch(err => {
        console.error(err);
      });
      // 拉取筛选项（mock 调试分支在共享 mixin 中，联调后删除）
      this.loadFilterOptions(newArgs, types.GET_LIST_LAYER);
    },
    // 显示商品信息弹窗
    showItemDialog(attr) {
      this.viewItem = attr;
    },
    // 关闭商品信息弹窗
    hideItemDialog() {
      this.viewItem = null;
    },
    // 显示到货通知
    setNotify(info) {
      if (!info || !info.id) return console.warn('缺少商品信息'), false;
      this.viewItem = null;
      this.notifyItem = info;
    },
    // 关闭到货通知
    hideNotifyDialog() {
      this.notifyItem = null;
    },
    // 加入购物车（与 Detail 同链路：按登录态走会员/游客加购接口）
    addToCart(args) {
      let { info, color, size, quantity } = args;
      const params = {
        product: String(info.id),
        product_option: [
          {
            option_id: color?.attribute_id,
            option_value: color?.id,
          },
          {
            option_id: size?.attribute_id,
            option_value: size?.option_id,
          },
        ],
        qty: quantity,
        sku: String(size.sku || size.id),
        is_presale: Number(color?.is_pre_sales) === 1,
      }
      if (this.isLogin) {
        api[types.ADD_TO_CUSTOMER_CART](params)
          .then((res) => {
            if (res?.code == 1) {
              this.showCartDialog(res);
              this.addToCartEnd(args);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        api[types.ADD_TO_CART_GUEST](params)
          .then((res) => {
            if (res?.code == 1) {
              this.showCartDialog(res);
              this.addToCartEnd(args);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    // 加购成功：关商品弹窗（避免盖住成功弹层）、按当前 header 实际高度吸顶、写入弹层数据
    showCartDialog(res) {
      this.viewItem = null;
      this.headerHeight = document.querySelector('.ot-header')?.offsetHeight || 0;
      this.cartInfo = res.data.info;
      this.cartInfo.info.cover = this.cartInfo?.info?.images[0];
    },
    // 加购成功：刷新购物车角标、自动关弹层、GA 埋点
    addToCartEnd(args) {
      let { info, color, quantity } = args;
      this.$store.dispatch(types.GET_CART_INFO);
      this.closeCartDialog(3000);
      this.gaTrack4AddToCart({
        id: info.style_number,
        name: info.name,
        price: info.price,
        quantity,
        category: info.category?.name,
        variant: color?.name,
      });
    },
    // GA add_to_cart 埋点
    gaTrack4AddToCart(info) {
      if (info?.id && window.gtag) {
        window.gtag("event", "add_to_cart", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "CNY",
          value: Number(info.price),
          items: [
            {
              item_id: info.id,
              item_name: info.name,
              item_brand: "Onitsuka Tiger",
              item_category: info.category,
              item_variant: info.variant,
              price: Number(info.price),
              quantity: Number(info.quantity),
              currency: "CNY",
            },
          ],
        });
      }
    },
    // 关闭加购成功弹层（closeCartDialog(0) 立即关闭）
    closeCartDialog(time) {
      setTimeout(() => {
        this.cartInfo = null;
      }, time);
    },
    // 加购成功 -> 立即结算
    toCheckout() {
      if (this.isLogin) {
        const { size, quantity } = this.cartInfo?.info || {}
        const params = { sku: String(size.sku || size.id), qty: quantity, cartType: 'is_buy_now' }
        api[types.BUY_NOW](params).then(async res => {
          if (res?.code == 1) {
            const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
            this.$router.push({ path: `/checkout?cartType=${params.cartType}&sku=${params.sku}&qty=${params.qty}&confirmCacheKey=${confirmCacheKey}` });
          } else {
            console.warn(res);
          }
        })
      } else {
        this.showLoginDialog();
      }
    },
    // 加购成功 -> 去购物车
    toCart() {
      this.$router.push({ path: "/cart" });
    },
    // 快速购买弹窗"立即购买"：登录走直购结算，未登录先登录、成功后自动重放直购
    toBuyNow(args) {
      let { size, quantity, skuStatus } = args;
      // 根据 SKU 状态决定购物袋类型：预售→is_presale，普通→is_buy_now
      const cartType = utils.getCartType(skuStatus === 'PreSales' ? 'presale' : 'buy_now');
      const params = { sku: String(size.sku || size.id), qty: quantity, cartType };
      if (this.isLogin) {
        this.execBuyNow(params);
      } else {
        // 未登录：暂存直购参数并弹登录框（returnUrl 回当前页），登录成功后由 isLogin watcher 自动重放
        this.viewItem = null; // 关商品弹窗再弹登录框
        this.pendingBuyNow = params;
        this.returnUrl = encodeURIComponent(this.$route.fullPath);
        this.showLoginDialog();
      }
    },
    // 执行直购：BUY_NOW 成功缓存后带 cartType 进结算页
    async execBuyNow(params) {
      try {
        const res = await api[types.BUY_NOW](params);
        if (res?.code == 1) {
          const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
          // URL 带 sku/qty/cartType: 刷新结算页时缓存丢失可重调 BUY_NOW 重建结算数据
          this.$router.push({ path: `/checkout?cartType=${params.cartType}&sku=${params.sku}&qty=${params.qty}&confirmCacheKey=${confirmCacheKey}` });
        } else {
          console.warn(res);
        }
      } catch (err) {
        console.error(err);
      }
    },
    showLoginDialog() {
      this.showLogin = true;
    },
    hideLoginDialog() {
      this.returnUrl = '';
      this.showLogin = false;
    },
    // 到货通知设置成功
    sendNotify() {
      this.hideNotifyDialog();
    },
    findItemById(id, items, parents = []) {
      // 遍历当前层级的所有项
      for (const item of items) {
        // 如果当前项的 id 匹配，则返回包含当前项及其所有父级的数组
        if (item.id === id) {
          return [...parents, item];
        }
        // 如果当前项有子项，则递归调用 findItemById 函数
        if (item.children && item.children.length > 0) {
          const foundItem = this.findItemById(id, item.children, [...parents, item]);
          // 如果在子项中找到了匹配的项，则返回包含当前项及其所有父级的数组
          if (foundItem) {
            return foundItem;
          }
        }
      }
      // 如果在当前层级和子项中都没有找到匹配的项，则返回空数组
      return null;
    }
  },
  computed: {
    // 列表中是否存在品牌项(供 ListItem 占位对齐)
    hasBrand() {
      return this.list?.some(i => i?.brand?.name) || false;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    breadcrumbList() {
      // const filteredData = this.categoryRes.breadcrumb.filter(item => item.show !== 0);
      const filteredData = this.categoryRes.breadcrumb || [];
      // 为面包屑构建累积 code 路径，如 3 -> 3/56 -> 3/56/666
      const codes = [];
      return filteredData.map(item => {
        if (item.code) codes.push(item.code);
        return { ...item, codePath: codes.join('/') };
      });
    },
    navs() {
      let ret = [];
      // 兼容新路由 (urlKey+code 合并) 和老路由 params.id
      const urlKey = this.getRouteCategoryKey();
      let ids = urlKey.split("-");
      let currId = ids?.length ? Number(ids[ids.length - 1]) : null;
      if (currId) {
        let navItem = this.findItemById(currId, this.$store.state.navList)
        ret = navItem?.map((i, index, array) => {
          const path = array.slice(0, index + 1).map(item => item.id).join('-');
          return {
            id: i.id, name: i.name, cover: i.cover, path
          }
        }) || []
      }
      return ret;
    },
    isGwMdEnablePoint() {
      return utils.isGwMdEnable(this.$store.state.commonConfig['gw_md_enable'], 'plp')
    }
  },
  watch: {
    // 登录成功后关闭登录弹框（Login 组件无事件回调，以登录态变化感知）
    isLogin(val) {
      if (val && this.showLogin) {
        this.hideLoginDialog();
      }
      // 登录成功且有暂存直购参数：自动重放 buyNow 流程
      if (val && this.pendingBuyNow) {
        const params = this.pendingBuyNow;
        this.pendingBuyNow = null;
        this.execBuyNow(params);
      }
    },
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // 老路由 URL 归一化 replace 引起的路由变化, 数据已加载, 跳过
      if (this.skipNextLoad) {
        this.skipNextLoad = false;
        return;
      }
      this.initWithArgs();
    }
  }
}
</script>

<style lang="scss" scoped>
.list-container {
  box-sizing: border-box;
  margin: auto;
  width: calc(100% - 20px);
  max-width: 1200px;
  padding: 0 .625rem;

  .list-section {
    max-width: 1200px;
    margin: 0 auto;

    .bread-crumbs {
      width: 100%;
      font-size: calc(.6875rem * 1.6);
      top: 0;
      left: 50%;
      z-index: 1;
      line-height: 1em;
      // line-height: 22px;
      // height: 22px;
      padding: .5em 0;
      text-align: left;

      a {
        font-size: calc(.6875rem * 1.6);
        color: #000;
        margin-right: 5px;

        &:hover {
          font-weight: 400;
          color: #999;
          text-decoration: underline;
        }

        &::after {
          color: #ccc;
          content: "/";
          margin-left: .4em;
          display: inline-block;
        }

        &:last-child::after {
          content: "";
        }
      }
    }

    .list-header {
      box-sizing: border-box;
      width: 100%;
      max-width: 1200px;
      border-bottom: 1px solid #b4b5b4;
      padding: 16px 0 16px;
      position: relative;
      margin: 0 0 calc(1.3125rem * 1.6);
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .list-title {
        font-weight: 400;
        font-size: calc(2rem * 1.6);
        line-height: normal;
        color: #000;
        cursor: pointer;
        display: block;
        float: left;
        margin: 0;
        margin-right: auto;
        padding: 0;
        max-width: calc(100% - 230px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: auto;
      }

      .list-header-extra {
        display: flex;

        .list-filter-mini {
          display: none;
          height: 40px;
          line-height: 40px;
          padding: 0 0 0 10px;
          text-align: left;
        }

        select {
          width: 100%;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
        }

        .list-limit {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-right: 10px;

          label {
            font-size: calc(.875rem * 1.6);
            letter-spacing: .025em;
            display: block;
            color: #000;
            margin-right: 5px;
            white-space: nowrap;
          }

          & ::v-deep .el-select {
            width: 65px;

            .el-input .el-input__inner {
              border: 2px solid #b4b5b4;
            }
          }
        }

        .list-sort {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          & ::v-deep .el-select {
            width: 110px;

            .el-input .el-input__inner {
              border: 2px solid #b4b5b4;

              &::placeholder {
                color: #333;
              }
            }
          }
        }
      }

      .list-filter-opts {
        display: none;
      }
    }

    .list-filter-opts-selected {
      box-sizing: border-box;
      margin-bottom: 10px;
      width: calc(100% - 20px);
      max-width: 1200px;
      margin: 0 auto calc(1.3125rem * 1.6);
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -ms-flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;

      .list-filter-flag {
        line-height: calc(1.875rem * 1.6);
        font-size: calc(.875rem * 1.6);
        color: #000;
        margin-right: 20px;
        text-transform: capitalize;
      }

      .filter-item {
        color: #000;
        background: #efefef;
        border: 1px solid #b4b5b4;
        margin: 5px 20px 5px 0;
        padding: 0 10px;
        line-height: calc(1.625rem * 1.6);
        font-size: calc(.875rem * 1.6);

        .filter-item-value {
          margin-left: 8px;

          .filter-item-remove {
            margin-left: 5px;
            cursor: pointer;
            color: #000;

            &:hover {
              text-decoration: none;
            }

            .iconfont {
              font-size: 12px;
            }
          }
        }
      }

      .clear-all {
        color: #666;
        font-size: calc(.75rem * 1.6);
        letter-spacing: .025em;
        cursor: pointer;
        text-decoration: underline;

        &:hover {
          font-weight: 400;
          color: #999;
          text-decoration: underline;
        }
      }
    }


    .list-wrapper {
      &::after {
        content: "";
        display: table;
        clear: both;
      }

      .filter-items {
        width: 230px;
        float: left;
      }


      .list-items {
        box-sizing: border-box;
        width: calc(100% - 230px - 50px);
        float: left;
        margin-left: 50px;

        .topic-banner {
          box-sizing: border-box;
          margin: auto;
          width: calc(100% - 20px);
          max-width: 1200px;
          margin-bottom: 10px;
          margin-top: 16px;

          img {
            width: 100%;
          }
        }





        .list-context {
          margin-bottom: 100px;

          .list-result {
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -ms-flex-wrap: wrap;
            -webkit-flex-wrap: wrap;
            flex-wrap: wrap;
            margin: 0;
            padding: 0;

            li {
              border-right: 1px solid #b4b5b4;
              border-bottom: 1px solid #b4b5b4;
              border-top: none;
              margin-top: 0;
              padding: 0;
              width: 33.33333%;
              position: relative;
              box-sizing: border-box;

              &:nth-child(3n+3) {
                border-right: none;
              }
            }
          }

          .paging {
            margin: 40px auto 0;
            position: relative;
            height: 60px;

            .list-footer-size {
              display: flex;
              align-items: center;
              position: absolute;
              top: 50%;
              right: 10px;
              transform: translateY(-50%);

              .list-footer-size-hits {
                font-weight: 400;
                font-size: calc(.875rem * 1.6);
                letter-spacing: .025em;
                color: #000;
                white-space: nowrap;
                margin-right: 4px;
              }

              & ::v-deep .el-select {
                width: 65px;

                .el-input .el-input__inner {
                  border: 2px solid #b4b5b4;
                }
              }
            }
          }
        }
      }
    }
  }

  .dialog {
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: url(../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
      z-index: 1010;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #FFF;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;
      border-radius: 4px;

      .dialog-header {
        position: relative;
        text-align: left;

        .dialog-title {
          border-bottom: 1px solid #b4b5b4;
          font-weight: 400;
          font-size: calc(1.375rem * 1.6);
          color: #000;
          text-transform: uppercase;
          padding: calc(1.25rem * 1.6) calc(1.25rem * 1.6) calc(0.5rem * 1.6) 0;
          margin: 0 calc(1.25rem * 1.6);
          width: calc(100% - 40px);
          box-sizing: border-box;
        }

        .dialog-close {
          width: 32px;
          height: 32px;
          position: absolute;
          top: -15px;
          right: -15px;
          padding: 0;
          border: none;
          border-radius: 0;
          margin: 0;
          background-color: transparent;
          font-size: 0;
          cursor: pointer;

          .close-icon {
            background-image: url(../assets/imgs/icons/onitsukatiger-close.svg);
            background-position: 0 0;
            background-repeat: no-repeat;
            height: 32px;
            width: 32px;
            margin: 0;
            padding: 0;
            display: block;
            text-indent: -99999px;
            overflow: hidden;
          }
        }
      }

      .dialog-body {
        box-sizing: border-box;
        display: flex;
        padding: 20px;
      }
    }

    &.view-item-dialog {
      .dialog-container {
        width: 920px;
        max-width: 95%;

        .dialog-header {
          .dialog-title {
            display: none;
          }
        }
      }
    }

    &.notify-dialog {
      .dialog-container {
        width: 834px;
        background-color: #efefef;

        .dialog-body {
          padding: 20px;
        }
      }
    }

    &.login-dialog {
      .dialog-container {
        width: 470px;
        height: 600px;

        .dialog-header {
          height: 40px;

          .dialog-close {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 32px;
            color: #999999;
            cursor: pointer;
          }
        }

        .dialog-body {
          & ::v-deep .login-component {
            width: 100%;

            .title {
              text-align: center;
            }

            .el-form {
              width: 80%;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .list-container {
    .list-section {
      .bread-crumbs {
        width: 100%;
        font-size: 12px;
        top: 0;
        left: 50%;
        z-index: 1;
        line-height: 1em;
        // line-height: 22px;
        // height: 22px;
        padding: 20px 0 0;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        a {
          font-size: 12px;
          color: #4B4F54;
          margin-right: 5px;

          &:hover {
            font-weight: 400;
            color: #999;
            text-decoration: underline;
          }

          &::after {
            color: #ccc;
            content: "/";
            margin-left: .4em;
            display: inline-block;
          }

          &:last-child::after {
            content: "";
          }
        }
      }

      .list-header {
        border-bottom: 0;
        flex-direction: column;
        justify-content: flex-start;
        padding: 0;


        .list-title {
          font-weight: 400;
          font-size: 20px !important;
          line-height: normal;
          line-height: 1em;
          color: #000;
          cursor: pointer;
          display: block;
          float: left;
          // margin: auto;
          // margin-right: auto;
          padding: 20px 0;
          max-width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }


        .list-header-extra {
          width: 100%;

          .list-filter-mini {
            overflow: hidden;
            display: block;
            padding-right: 31px;
            box-sizing: border-box;
            border: 1px solid #b4b5b4;
            border-radius: 2px;
            background: #efefef url(../assets/imgs/icons/plus.svg) no-repeat scroll;
            background-position: right 10px center;
            position: relative;
            clear: left;
            cursor: pointer;
            float: left;
            width: calc(50% - 5px);

            &.active {
              background: #efefef url(../assets/imgs/icons/minus.svg) no-repeat scroll;
              background-position: right 10px center;
            }
          }

          .list-limit {
            display: none;
          }

          .list-sort {
            width: calc(50% - 5px);
            height: 40px;
            margin: 0;
            margin-left: calc(.625rem * 1.6);
            overflow: hidden;
            display: block;
            // padding-right: 31px;
            box-sizing: border-box;
            border: 1px solid #b4b5b4;
            border-radius: 2px;
            background: #efefef url(../assets/imgs/icons/plus.svg) no-repeat scroll;
            background-position: right 10px center;
            position: relative;

            & ::v-deep .el-select {
              width: 100%;

              .el-input {
                .el-input__inner {
                  border: 0;
                  background: transparent;
                }

                .el-input__suffix {
                  display: none;
                }
              }
            }
          }
        }

        .list-filter-opts {
          display: block !important;
          margin-top: 5px;
          background: #efefef;
          border: 1px solid #b4b5b4;
          float: left;
          display: none;
          padding: calc(.6875rem * 1.6);
          width: calc(100% - 24px);

          .list-filter-opts-close {
            font-weight: 400;
            font-size: 12px;
            padding: 15px 0 5px;
            text-align: center;
            color: #333;
            cursor: pointer;
          }
        }
      }

      .list-wrapper {
        .filter-items {
          display: none;
        }

        .list-items {
          width: 100%;
          margin: 0;


          .list-context {
            .list-result {
              li {
                width: 50%;
                border-bottom: 1px solid #b4b5b4;

                &:nth-child(3n+3) {
                  border-right: 1px solid #b4b5b4;
                }

                &:nth-child(2n+2) {
                  border-right: none;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .list-container {
    .list-section {
      .list-wrapper {
        .list-items {


          .list-context {
            margin-bottom: 10px;

            .paging {
              .pagination-wrapper {
                .pagination-hits {
                  text-align: left;
                  margin-bottom: 20px;
                }
              }

              .list-footer-size {
                top: 14%;
              }
            }
          }
        }

        .list-header {

          .list-title {
            font-size: 20px;
          }
        }
      }
    }

    .dialog {
      &.view-item-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
        }
      }

      &.notify-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
          background: #FFF;
        }
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .list-container {
    .dialog {
      &.view-item-dialog {
        .dialog-container {
          top: 50px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-title {
              display: block;
            }

            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.notify-dialog {
        .dialog-container {
          top: 50px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.login-dialog {
        .dialog-container {
          position: fixed;
          top: 0;
          left: 0;
          transform: none;
          // transform: translate(-50%, 0);
          background: #FFF;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-body ::v-deep .login-component {
            .el-form {
              width: calc(100% - 40px);
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.list-container .dialog.view-item-dialog .dialog-container {
  top: max(50%, 370px);
}

.list-container .dialog.notify-dialog .dialog-container {
  top: max(50%, 355px);
}
</style>
